import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchMe, logout as apiLogout, exchangeSession } from "@/lib/api";

const AuthCtx = createContext({ user: null, loading: true, refresh: () => {}, signOut: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const u = await fetchMe();
      setUser(u);
    } catch (e) {
      if (e?.response?.status !== 401) console.error("Failed to load /auth/me:", e);
      setUser(null);
    }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    // Skip /auth/me if returning from OAuth callback — AuthCallback handles it first
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const signOut = async () => {
    try { await apiLogout(); } catch (e) { console.error("Logout failed:", e); }
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, refresh, signOut }}>{children}</AuthCtx.Provider>;
}

export function useAuth() { return useContext(AuthCtx); }

export function startGoogleLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
